import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Particle from "../Particle";
import eventLoop from "../../Assets/Blogs/Event_loop_node_js.png";
import groqApi from "../../Assets/Blogs/GroqApi.png";
import microservices from "../../Assets/Blogs/monolithic_microservices_architecture.jpeg";
import grpc from "../../Assets/Blogs/microservice-architecture.png";
import communicationPatterns from "../../Assets/Blogs/communication-patterns.png";
import BlogCard from "../Cards/Cards";
import webGatewayInterfaces from "../../Assets/Blogs/Web Gateway Interfaces.png";
import wsgiAsgi from "../../Assets/Blogs/wsgi-vs-asgi.png";
import threads from "../../Assets/Blogs/Threads.png";
import agenticAi from "../../Assets/Blogs/Agentic_AI.png";
import agenticAiWorkflow from "../../Assets/Blogs/Agentic_AI_Workflows.png";
import agenticAiTools from "../../Assets/Blogs/AgenticAiTools.png";
import customWebSearchTools from "../../Assets/Blogs/webSearchTool.png";
import MCPArchitecture from "../../Assets/Blogs/MCP_Architecture.png";
import SQLBlog from "../../Assets/Blogs/pagination_one_to_many_join.png";
import fde from "../../Assets/Blogs/FDE.png";

function Blogs() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Blogs </strong>
        </h1>
        <p style={{ color: "white" }}>Please find list of my blogs</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={fde}
              isBlog={true}
              isLinkedin={true}
              title="FDE – More Than Just an Engineer, A Problem Solver"
              description="This article explores how Forward Deployed Engineers bridge the gap between AI capabilities and real-world business problems by designing, building, deploying, and maintaining intelligent solutions."
              ghLink="https://lnkd.in/p/dN6T_gJB"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={SQLBlog}
              isBlog={true}
              title="Pagination with One-to-Many Join and ORMs strategies"
              description="This explores classic sql problem when having pagination along with nested joins with one-to-many relation. It discuss different strategies and its comparison that ORMs used to have correct pagination and data"
              ghLink="https://medium.com/@rehmanakram03/pagination-with-one-to-many-relationships-in-orms-why-subqueries-exist-and-when-to-fetch-9290c6b8c363"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={MCPArchitecture}
              isBlog={true}
              title="Model Context Protocol - MCP"
              description="This explores that what is MCP, what problem does it resolves in Agentic AI systems, MCP compoenents and its architecture"
              ghLink="https://medium.com/@rehmanakram03/mcp-52d5f29767e4"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={customWebSearchTools}
              isBlog={true}
              title="Mastering AI Agents: Custom web search tool"
              description="This blog explains how we create custom tool and agent and integrate that custom tool in our agent as tool. For demonstration purposes i have added web search tool using serpapi and openai"
              ghLink="https://medium.com/@rehmanakram03/%EF%B8%8F-%EF%B8%8F-mastering-ai-agents-adding-a-custom-web-search-tool-for-any-model-371f07fcf33c"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={agenticAiTools}
              isBlog={true}
              title="Mastering AI Agents: Tools, Orchestration, and Seamless Agent Hand-offs"
              description="This blog explains what are tools and how they can be implemented in Agentic AI Systems and workflows. It also explains how to orchestrate agents and hand-off between agents."
              ghLink="https://medium.com/@rehmanakram03/mastering-ai-agents-tools-orchestration-and-seamless-agent-hand-offs-843673cee860"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={agenticAiWorkflow}
              isBlog={true}
              title="Exploring AI Systems, Agentic AI, and Workflows Design Patterns"
              description="This blog explains Agentic AI Systems and workflows to create effective AI solutions. "
              ghLink="https://medium.com/@rehmanakram03/exploring-ai-systems-agentic-ai-and-workflows-design-patterns-ef332c68393c"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={agenticAi}
              isBlog={true}
              title="Agentic AI, MCPs, Platforms and Frameworks"
              description="This blog explains my roadmap to Agentic AI, MCPs, Platforms and Frameworks."
              ghLink="https://medium.com/@rehmanakram03/agentic-ai-platforms-frameworks-and-way-forward-8e2fb7c4b819"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={threads}
              isBlog={true}
              title="Libuv thread pool threads vs OS threads - NODE JS "
              description="This blog will explain that node js offloads some operations to libuv thread pool threads and some opeations os OS threads with practical code examples"
              ghLink="https://medium.com/@rehmanakram03/libuv-thread-pool-vs-os-threads-in-node-js-179d86421ab7"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={wsgiAsgi}
              isBlog={true}
              title="WSGI & ASGI"
              description="A blog explaining the difference between WSGI and ASGI, and how they work."
              ghLink="https://medium.com/@rehmanakram03/wsgi-asgi-asyncio-library-7c3b4a4a247c"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={webGatewayInterfaces}
              isBlog={true}
              title="Understanding Web Gateway Interfaces"
              description="Exploring Web gateway interfaces that how requests from clients are being forwarded to backend application"
              ghLink="https://medium.com/@rehmanakram03/understanding-web-gateway-interfaces-the-bridge-between-web-servers-and-applications-41b885b7113e"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={groqApi}
              isBlog={true}
              title="Exploring Groq API with Streamlit by creating a simple chatbot using llama3 llm"
              description="In this blog, I have explored Groq API (AI Inference) to call open source models as an api. Further explored Streamlit that how it provides quick support for creating UI and deploy on cloud freely. I used Streamlit and Groq API to create simple chatbot using llama3 llm."
              ghLink="https://medium.com/@rehmanakram03/building-a-chatbot-with-groq-apis-llama-3-and-streamlit-with-deployment-on-cloud-74ef041f60d2"
            />
          </Col>
          <Col md={4} className="project-card">
            <BlogCard
              imgPath={eventLoop}
              isBlog={true}
              title="Internals of Node-JS Event loop"
              description="In this blog, i have discussed in detailed with an example that how event loop works in a node js."
              ghLink="https://medium.com/@rehmanakram03/internals-of-node-js-event-loop-74e79d31bbfc"
            />
          </Col>

          <Col md={4} className="project-card">
            <BlogCard
              imgPath={microservices}
              isBlog={true}
              title="Monolithic Vs Microservice Architecture"
              description="A brief blog for comparision between monolithic and microservices architecture."
              ghLink="https://focusteck.com/monolithic-vs-microservice-architecture/"
            />
          </Col>

          <Col md={4} className="project-card">
            <BlogCard
              imgPath={grpc}
              isBlog={true}
              title="Microservices Communication (API-Gateway) Using gRPC"
              description="A blog with github repos for gRPC communication between microservices."
              ghLink="https://medium.com/@rehmanakram03/microservices-communication-api-gateway-pattern-using-grpc-a165c7425bfb"
            />
          </Col>

          <Col md={4} className="project-card">
            <BlogCard
              imgPath={communicationPatterns}
              isBlog={true}
              title="Interservice Communication: Synchronous vs Asynchronous Communication"
              description="A blog, briefly describing synchronous and asynchronous communication patterns in microservices architecture."
              ghLink="https://medium.com/@rehmanakram03/interservice-communication-synchronous-asynchronous-communication-e22ca8291c15"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Blogs;
